import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// components
import {
    ModalMask,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ProgressRing,
} from '../atom';

type DragablePosition = {
    clientX: number;
    clientY: number;
    movementX: number;
    movementY: number;
};

@Component({
    components: {
        ModalMask,
        Modal,
        ModalHeader,
        ModalBody,
        ModalFooter,
        ProgressRing,
    },
})
export default class PopupModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean;
    @Prop({ type: Boolean, default: false }) busy!: boolean;
    @Prop({ type: String, default: '' }) header!: string;
    @Prop({ type: String }) description!: string;
    @Prop({ type: String, default: 'auto' }) wValue!: string;
    @Prop({ type: String, default: 'auto' }) hValue!: string;
    

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    positions: DragablePosition = {
        clientX: 0,
        clientY: 0,
        movementX: 0,
        movementY: 0,
    };

    positionStyle: any = {};

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    dragMouseDown(event: MouseEvent) {
        event.preventDefault();
        // get the mouse cursor position at startup:
        this.positions.clientX = event.clientX;
        this.positions.clientY = event.clientY;
        document.onmousemove = this.elementDrag;
        document.onmouseup = this.closeDragElement;
    }

    elementDrag(event: MouseEvent) {
        event.preventDefault();
        this.positions.movementX = this.positions.clientX - event.clientX;
        this.positions.movementY = this.positions.clientY - event.clientY;
        this.positions.clientX = event.clientX;
        this.positions.clientY = event.clientY;
        // set the element's new position:
        // this.$refs.draggableContainer.style.top =
        //     this.$refs.draggableContainer.offsetTop -
        //     this.positions.movementY +
        //     'px';
        // this.$refs.draggableContainer.style.left =
        //     this.$refs.draggableContainer.offsetLeft -
        //     this.positions.movementX +
        //     'px';
    }

    closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
    }
}
